var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgRunwayBars(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.7 4.736h5.184a1.7 1.7 0 010 3.401H5.701a1.7 1.7 0 010-3.401zm0 5.669h9.233a1.7 1.7 0 010 3.401H5.701a1.7 1.7 0 110-3.401zm13.769 9.07H5.7a1.7 1.7 0 110-3.401h13.685c1.54-.009 2.816-.475 3.826-1.398l.028-.024a.701.701 0 011.094.808l-.078.19c-.388.933-.718 1.614-.99 2.042l-.054.083c-.728 1.086-1.943 1.652-3.644 1.698a1.715 1.715 0 01-.1.002zm6.44-5.585L26 11.77a.485.485 0 00-.76-.421l-1.783 1.222a.486.486 0 00.133.866c.429.131.725.237.889.319l.043.022c.114.064.277.187.486.37l.093.082a.485.485 0 00.81-.341z", fill: "#242B42" }),
        React.createElement("path", { opacity: 0.33, fillRule: "evenodd", clipRule: "evenodd", d: "M19.469 4.736H5.7a1.7 1.7 0 100 3.401h13.768a1.7 1.7 0 000-3.401zm0 5.669H5.7a1.7 1.7 0 000 3.401h13.768a1.7 1.7 0 000-3.401z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgRunwayBars);
export default ForwardRef;
